import { render, staticRenderFns } from "./QuickLinksTab.vue?vue&type=template&id=453c3779&scoped=true"
import script from "./QuickLinksTab.vue?vue&type=script&lang=js"
export * from "./QuickLinksTab.vue?vue&type=script&lang=js"
import style0 from "./QuickLinksTab.vue?vue&type=style&index=0&id=453c3779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c3779",
  null
  
)

export default component.exports